import { type ReactNode } from 'react'

// Spelled out, not interpolated: Tailwind only emits classes it can see.
const COLS = { 2: 'md:grid-cols-2', 3: 'md:grid-cols-3' } as const

/** Two or three cards side by side; the whole width vocabulary the page has. */
const Grid = ({ cols, children }: { cols: 2 | 3; children: ReactNode }) => (
  <div className={`grid items-start gap-4 ${COLS[cols]}`}>{children}</div>
)

export default Grid
